module.exports = __webpack_public_path__ + "assets/img/in.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/in.png
// module id = 696
// module chunks = 0